import { Thunk, UiStatus } from '../../../common/type';
import { selectCustomerId } from './ads-checkout-selector';
import { getAdsTypeInfo, getCustomerCustomPricing } from './ads-checkout-service';
import {
  AdsCheckoutActionKey,
  CheckoutScreen,
  IAdsDiscount,
  IAdsInfo,
  IAdsTypeInfo
} from './ads-checkout-type';
import { validateAdsSelection } from './ads-checkout-util';

export type AdsCheckoutAction =
  | { type: AdsCheckoutActionKey.SetAdsTypeInfo; payload: { adsTypeInfo: IAdsTypeInfo[] } }
  | { type: AdsCheckoutActionKey.SetCustomerId; payload: { customerId: string } }
  | { type: AdsCheckoutActionKey.SetAds; payload: { ads: IAdsInfo[] } }
  | { type: AdsCheckoutActionKey.AddAds }
  | {
      type: AdsCheckoutActionKey.SetAdsName;
      payload: { index: number; name: string };
    }
  | {
      type: AdsCheckoutActionKey.SetAdsType;
      payload: { index: number; typeId: string };
    }
  | { type: AdsCheckoutActionKey.RemoveAds; payload: { index: number } }
  | { type: AdsCheckoutActionKey.SetDiscounts; payload: { discounts: IAdsDiscount[] } }
  | { type: AdsCheckoutActionKey.SetScreen; payload: { screen: CheckoutScreen } }
  | { type: AdsCheckoutActionKey.SetUiStatus; payload: { status: UiStatus } }
  | { type: AdsCheckoutActionKey.SetErrorMessage; payload: { error: string } };

export const adsCheckoutActionCreator = {
  SetAdsTypeInfo: (adsTypeInfo: IAdsTypeInfo[]): AdsCheckoutAction => ({
    type: AdsCheckoutActionKey.SetAdsTypeInfo,
    payload: { adsTypeInfo }
  }),
  SetCustomerId: (customerId: string): AdsCheckoutAction => ({
    type: AdsCheckoutActionKey.SetCustomerId,
    payload: { customerId }
  }),
  SetAds: (ads: IAdsInfo[]): AdsCheckoutAction => ({
    type: AdsCheckoutActionKey.SetAds,
    payload: { ads }
  }),
  AddAds: (): AdsCheckoutAction => ({ type: AdsCheckoutActionKey.AddAds }),
  SetAdsName: (index: number, name: string): AdsCheckoutAction => ({
    type: AdsCheckoutActionKey.SetAdsName,
    payload: { index, name }
  }),
  SetAdsType: (index: number, typeId: string): AdsCheckoutAction => ({
    type: AdsCheckoutActionKey.SetAdsType,
    payload: { index, typeId }
  }),
  RemoveAds: (index: number): AdsCheckoutAction => ({
    type: AdsCheckoutActionKey.RemoveAds,
    payload: { index }
  }),
  SetDiscounts: (discounts: IAdsDiscount[]): AdsCheckoutAction => ({
    type: AdsCheckoutActionKey.SetDiscounts,
    payload: { discounts }
  }),
  SetScreen: (screen: CheckoutScreen): AdsCheckoutAction => ({
    type: AdsCheckoutActionKey.SetScreen,
    payload: { screen }
  }),
  SetUiStatus: (status: UiStatus): AdsCheckoutAction => ({
    type: AdsCheckoutActionKey.SetUiStatus,
    payload: { status }
  }),
  SetErrorMessage: (error: string): AdsCheckoutAction => ({
    type: AdsCheckoutActionKey.SetErrorMessage,
    payload: { error }
  }),
  // thunk
  InitSelection: (): Thunk<void, AdsCheckoutAction> => (dispatch, getState) => {
    dispatch(adsCheckoutActionCreator.SetUiStatus(UiStatus.Busy));

    const customerId = selectCustomerId(getState());

    Promise.all([getAdsTypeInfo(), getCustomerCustomPricing(customerId)])
      .then(([adsTypeInfo, customerPricing]) => {
        dispatch(adsCheckoutActionCreator.SetAdsTypeInfo(adsTypeInfo));
        dispatch(adsCheckoutActionCreator.SetDiscounts(customerPricing.discounts));
        dispatch(adsCheckoutActionCreator.SetUiStatus(UiStatus.Idle));
        dispatch(adsCheckoutActionCreator.AddAds());
      })
      .catch(() => dispatch(adsCheckoutActionCreator.SetUiStatus(UiStatus.Error)));
  },
  Checkout: (): Thunk<void, AdsCheckoutAction> => (dispatch, getState) => {
    dispatch(adsCheckoutActionCreator.SetErrorMessage(''));
    const state = getState().adsCheckout;

    const error = validateAdsSelection(state);

    if (error) {
      dispatch(adsCheckoutActionCreator.SetErrorMessage(error));
      return;
    }

    dispatch(adsCheckoutActionCreator.SetScreen(CheckoutScreen.checkout));
  }
};



// WEBPACK FOOTER //
// ./src/modules/ads-checkout/parts/ads-checkout-action.ts